import { render, staticRenderFns } from "./InstituteProfile.vue?vue&type=template&id=d9be7e80&"
import script from "./InstituteProfile.vue?vue&type=script&lang=js&"
export * from "./InstituteProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports